import { render, staticRenderFns } from "./AgroOnOff.vue?vue&type=template&id=60a9b2f0&scoped=true&"
import script from "./AgroOnOff.vue?vue&type=script&lang=ts&"
export * from "./AgroOnOff.vue?vue&type=script&lang=ts&"
import style0 from "./agro-on-off.scss?vue&type=style&index=0&id=60a9b2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9b2f0",
  null
  
)

export default component.exports